
            const data = {"name":"search","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M53.13 58.33l-10.4-10.39-.18-.19a25.71 25.71 0 115.2-5.19l.18.18 10.4 10.4a3.68 3.68 0 11-5.2 5.2zm-39-18.19a18.38 18.38 0 100-26 18.37 18.37 0 00.01 26z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                